"use strict";

exports.__esModule = true;
exports.getStyles = exports.getState = exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactWaypoint = _interopRequireDefault(require("react-waypoint"));

var _propTypes = require("prop-types");

var _reactMotion = require("react-motion");

var _ramda = require("ramda");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styles = require("@qc-modules/styles");

var _loadingIndicator = _interopRequireDefault(require("../../legacy/loading-indicator"));

var _primitives = _interopRequireDefault(require("../../primitives"));

var _searchItem = _interopRequireDefault(require("../search-item"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var ResultsContainer = (0, _styledComponents["default"])(_primitives["default"].Flex).withConfig({
  displayName: "search-results__ResultsContainer",
  componentId: "sc-5okxfq-0"
})(["overflow-x:hidden;overflow-y:auto;-webkit-overflow-scrolling:touch;&::-webkit-scrollbar{width:10px;}&::-webkit-scrollbar-track{border-radius:10px;padding-right:1px;}&::-webkit-scrollbar-thumb{background-color:", ";border-radius:10px;}"], function (props) {
  return (0, _styles.colors)("light-grey", props);
});
var ResultsCount = (0, _styledComponents["default"])(_primitives["default"].Text).withConfig({
  displayName: "search-results__ResultsCount",
  componentId: "sc-5okxfq-1"
})(["color:", ";letter-spacing:0.5px;"], function (props) {
  return (0, _styles.colors)("body-grey", props);
});
var IsLoading = (0, _styledComponents["default"])(_loadingIndicator["default"]).withConfig({
  displayName: "search-results__IsLoading",
  componentId: "sc-5okxfq-2"
})(["display:flex;align-self:center;margin:0 auto;"]);
var propTypes = {
  // Function to cancel search
  cancelSearch: _propTypes.func,

  /** */
  className: _propTypes.string,

  /** Number of results  */
  count: _propTypes.number,
  // Funcation to fetch more search results
  fetchMoreResults: _propTypes.func,

  /** Loading check */
  isLoading: _propTypes.bool,
  // Text to show after result count
  resultCountText: _propTypes.string,

  /** Search Results */
  results: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    className: _propTypes.string,
    description: _propTypes.string,
    id: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
    title: _propTypes.string,
    url: _propTypes.string
  })),
  // Flag to allow loading more results
  showLoadMoreResults: _propTypes.bool
};
var defaultProps = {
  resultCountText: "results found"
};

var syncSpring = function syncSpring(val) {
  return (0, _reactMotion.spring)(val, {
    damping: 25,
    stiffness: 200
  });
};

var getState = function getState(prevInterpolatedStyles, index) {
  if (prevInterpolatedStyles === void 0) {
    prevInterpolatedStyles = [];
  }

  if (index === 0 && prevInterpolatedStyles.length) {
    return syncSpring(1);
  }

  if (prevInterpolatedStyles[index - 1]) {
    return syncSpring(prevInterpolatedStyles[index - 1].style.state);
  }

  return 0;
};

exports.getState = getState;

var getStyles = function getStyles(items) {
  return function (prevInterpolatedStyles) {
    return items.map(function (item, index) {
      return {
        data: item,
        key: item.key,
        style: {
          state: getState(prevInterpolatedStyles, index)
        }
      };
    });
  };
};

exports.getStyles = getStyles;

var StaggeredFadeUp = function StaggeredFadeUp(_ref) {
  var children = _ref.children,
      className = _ref.className,
      ItemContainer = _ref.ItemContainer;
  return /*#__PURE__*/_react["default"].createElement(_reactMotion.TransitionMotion, {
    styles: getStyles(children)
  }, function (interpolatingStyles) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: className
    }, (0, _ramda.map)(function (item) {
      return /*#__PURE__*/_react["default"].createElement(ItemContainer, {
        key: item.key,
        style: {
          opacity: item.style.state,
          transform: "translate3d(0, " + (item.style.state - 1) * -100 + "px, 0)"
        }
      }, item.data);
    }, interpolatingStyles));
  });
};

StaggeredFadeUp.propTypes = {
  ItemContainer: _propTypes.string,
  children: _propTypes.node,
  className: _propTypes.string
};
StaggeredFadeUp.defaultProps = {
  ItemContainer: "div"
};
/**
 * Search bar includes Input Primitive with a search icon and a container for
 * suggested search terms.
 */

var SearchResults = function SearchResults(_ref2) {
  var className = _ref2.className,
      _ref2$count = _ref2.count,
      count = _ref2$count === void 0 ? 0 : _ref2$count,
      isLoading = _ref2.isLoading,
      results = _ref2.results,
      _ref2$resultCountText = _ref2.resultCountText,
      resultCountText = _ref2$resultCountText === void 0 ? "results found" : _ref2$resultCountText,
      showLoadMoreResults = _ref2.showLoadMoreResults,
      fetchMoreResults = _ref2.fetchMoreResults,
      cancelSearch = _ref2.cancelSearch;
  return /*#__PURE__*/_react["default"].createElement(ResultsContainer, {
    className: className,
    flexDirection: "column",
    mr: "1px",
    pr: [0, 4],
    pt: 2,
    width: [1, 2 / 3]
  }, /*#__PURE__*/_react["default"].createElement(ResultsCount, {
    fontSize: 1,
    pb: 2
  }, count, " ", resultCountText), isLoading ? /*#__PURE__*/_react["default"].createElement(IsLoading, null) : /*#__PURE__*/_react["default"].createElement(StaggeredFadeUp, null, (0, _ramda.is)(Array, results) ? (0, _ramda.map)(function (result) {
    return /*#__PURE__*/_react["default"].createElement(_searchItem["default"], _extends({
      key: result.id
    }, result));
  }, results) : null), showLoadMoreResults ? /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
    py: 2
  }, /*#__PURE__*/_react["default"].createElement(_reactWaypoint["default"], {
    onEnter: fetchMoreResults,
    onLeave: cancelSearch
  }), /*#__PURE__*/_react["default"].createElement(IsLoading, null)) : null);
};

SearchResults.propTypes = propTypes;
SearchResults.defaultProps = defaultProps;
SearchResults.displayName = "Modules.SearchResults";
var _default = SearchResults;
exports["default"] = _default;